import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../../store/actions";
import {
  fetchSelloutUploadImdlAPI,
  selloutGetUploadUrl,
  selloutUploadFile
} from "../../../../api/endpoint";

function* getSelloutUploadImdlRolesSaga(action) {
  try {
    const _api = yield call(fetchSelloutUploadImdlAPI, action.payload);
    yield put(actions.setSelloutImdlRoles(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    console.log(error);
    yield put(commonActions.setLoading(false));
  }
}

function* selloutUploadFilesSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(selloutGetUploadUrl, action.payload?.getUploadUrlPayload);
    if (_api?.data?.success) {
      const _upload = yield call(selloutUploadFile, { uploadUrl: _api?.data?.results?.uploadUrl, file: action.payload.file })
      if (_upload) {
        yield put(commonActions.setLoading(false));
        yield put(commonActions.setRedirect(true));
        yield put(
          commonActions.setAlert({
            message: "File Uploaded Successfully",
            alertType: "success",
            showToast: true,
          })
        );
      }
    }
  } catch (error) {
    console.log(error);
    yield put(commonActions.setError(true));
    yield put(commonActions.setRedirect(false));
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message || "File Upload Failed",
        alertType: "error",
        showToast: true,
      })
    );
    yield put(commonActions.setLoading(false));
  }
}

export function* watchSelloutFileUploadSaga() {
  yield all([
    takeEvery(actionTypes.SELLOUT_UPLOAD_IMDL_ROLES, getSelloutUploadImdlRolesSaga),
    takeEvery(actionTypes.SETLLOUT_UPLOAD_FILES, selloutUploadFilesSaga),
  ]);
}
